// extracted by mini-css-extract-plugin
export default {"screen-xl":"2160px","screen-lg":"1440px","screen-md":"1023px","screen-sm":"767px","screen-xs":"390px","custom-easing":"cubic-bezier(0.645, 0.045, 0.355, 1)"};